import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DictationActivityEvent } from '../../models';
import { PipelineActivityLogService } from '../../services/pipeline-activity-log.service';
import { getAvatarColor, getInitials } from '../../utils/avatar.util';

@Component({
  selector: 'app-patient-activity-modal',
  templateUrl: './patient-activity-modal.component.html',
  styleUrls: ['./patient-activity-modal.component.scss'],
})
export class PatientActivityModalComponent implements OnInit, OnDestroy {
  @Input() patientId: string;
  @Input() patientName: string;
  @Input() mrn: string;

  events: DictationActivityEvent[] = [];
  loading = true;
  private eventSource?: EventSource;

  constructor(
    public activeModal: NgbActiveModal,
    private pipelineActivityLogService: PipelineActivityLogService
  ) {}

  get initials(): string {
    return getInitials(this.patientName);
  }

  get avatarColor(): string {
    return getAvatarColor(this.patientId || this.patientName || '');
  }

  ngOnInit(): void {
    if (!this.patientId) {
      this.loading = false;
      return;
    }
    this.pipelineActivityLogService
      .getHistoryByPatient(this.patientId)
      .then((res) => {
        this.events = res?.data ?? [];
        this.loading = false;
        this.subscribeToStream();
      })
      .catch((err) => {
        console.error('Failed to load patient activity history:', err);
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    this.eventSource?.close();
  }

  private subscribeToStream(): void {
    this.eventSource = this.pipelineActivityLogService.streamByPatient(this.patientId);
    this.eventSource.addEventListener('activity-log', (event: MessageEvent) => {
      try {
        this.events = [...this.events, JSON.parse(event.data)];
      } catch (err) {
        console.error('Failed to parse activity-log SSE event:', err);
      }
    });
  }

  close(): void {
    this.activeModal.close();
  }
}
